module.exports = __webpack_public_path__ + "static/media/RedemptionsGuildIcon.539654d4.png";